<template>
    <div class="Information">
        <div class="row">
            <div class="col col-md-4">
                <h4>General Info</h4>
                <p>
                    <span class="bold">Family Name: </span>
                    <StringEditor v-bind:old-value="FamilyRecordData.Family.Name"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Family Name"
                                  property-name="Name"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  v-bind:required="true" />
                </p>
                <p>
                    <span class="bold">Status: </span><span>{{FamilyRecordData.Family.Status}}</span>

                </p>
                <p>
                    <span class="bold">Max Approved Beds Not To Exceed: </span>
                    <IntegerEditor v-bind:old-value="FamilyRecordData.Family.TotalFosterBeds"
                                   v-bind:record-id="FamilyRecordData.Family.Id"
                                   v-bind:edit-mode="EditMode"
                                   data-label="Max Legal Foster Beds"
                                   property-name="TotalFosterBeds"
                                   update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                   v-bind:required="true"
                                   :global-update="true" />
                </p>
                <p>
                    <span class="bold">Max Preferred Beds Family Desires: </span>
                    <IntegerEditor v-bind:old-value="FamilyRecordData.Family.TotalBedCapacity"
                                   v-bind:record-id="FamilyRecordData.Family.Id"
                                   v-bind:edit-mode="EditMode"
                                   data-label="Current Max Beds"
                                   property-name="TotalBedCapacity"
                                   update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                   v-bind:required="true"
                                   :global-update="true" />
                </p>
                <p>
                    <span class="bold">Respite Only: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.RespiteOnly"
                                  v-bind:old-value-text="FamilyRecordData.Family.RespiteOnly  != null ? FamilyRecordData.Family.RespiteOnly == true ? 'Yes' : 'No' : ''"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Respite Only"
                                  property-name="RespiteOnly"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="true"
                                  v-bind:options="YesOrNoOption" />

                </p>
                <p v-if="!IsPNW">
                    <span class="bold">Porting Family: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.PortingFamily"
                                  v-bind:old-value-text="FamilyRecordData.Family.PortingFamily  != null ? FamilyRecordData.Family.PortingFamily == true ? 'Yes' : 'No' : ''"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Porting Family"
                                  property-name="PortingFamily"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="true"
                                  v-bind:options="YesOrNoOption" />

                </p>
                <p>
                    <span class="bold">Preferred Language: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.PreferredLanguage"
                                  v-bind:old-value-text="FamilyRecordData.Family.PreferredLanguage"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Preferred Language"
                                  property-name="PreferredLanguage"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="true"
                                  v-bind:options="Languages" />

                </p>
                <p>
                    <span class="bold">Provider Number: </span>
                    <StringEditor v-bind:old-value="FamilyRecordData.Family.ProviderNumber"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Provider Number"
                                  property-name="ProviderNumber"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  v-bind:required="false" />

                </p>
                <p>
                    <span class="bold">Sage ID: </span>
                    <StringEditor v-bind:old-value="FamilyRecordData.Family.SageID"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Family Sage ID"
                                  property-name="SageID"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  edit-permission="RecordEdit.SageID"
                                  v-bind:required="false" />

                </p>
                <p>
                    <span class="bold">Placement Types Allowed: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.FamilyProgramServiceCapacity"
                                  v-bind:old-value-text="FamilyRecordData.Family.FamilyProgramServiceCapacity"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Placement Types Allowed"
                                  property-name="FamilyProgramServiceCapacity"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="true"
                                  v-bind:options= " FamilyRecordData.FamilyProgramMemberships.length > 0 && FamilyRecordData.FamilyProgramMemberships[0].SubProgram.Name == 'Las Vegas Foster' ?
                                  [] :
                                  FamilyRecordData.FamilyProgramMemberships[0].SubProgram.Region == 'PNW' ?
                                  [
                                      {text:'CPA Foster Care',value:'CPA Foster Care'},
                                      {text:'BRS',value:'BRS'},
                                      {text:'Respite Only',value:'Respite Only'},
                                      {text:'Receiving Care',value:'Receiving Care'},
                                      {text:'Hybrid',value:'Hybrid'}
                                  ] :
                                  [
                                      {text:'Normal Foster Only',value:'Normal Foster Only'},
                                      {text:'ISFC Medical',value:'ISFC Medical'},
                                      {text:'ISFC Behavioral',value:'ISFC Behavioral'},
                                      {text:'ISFC Behavioral/CSEC',value:'ISFC Behavioral/CSEC'},    
                                      {text:'ISFC Medical & Behavioral',value:'ISFC Medical & Behavioral'},
                                      {text:'ISFC Medical & Behavioral/CSEC',value:'ISFC Medical & Behavioral/CSEC'},
                                  ]"
                                  />

                </p>
                <p>
                    <span class="bold">Territory/Region: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.SubProgramTerritory != null ? FamilyRecordData.Family.SubProgramTerritory.Id : null"
                                  v-bind:old-value-text="FamilyRecordData.Family.SubProgramTerritory != null ? FamilyRecordData.Family.SubProgramTerritory.Name : 'UNASSIGNED'"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  record-id-name="FosterResourceFamilyID"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Territory"
                                  property-name="SubProgramTerritoryID"
                                  update-method="Foster/ResourceFamily/UpdateFamilyTerritory"
                                  :required="true"
                                  v-bind:options="SubProgramTerritories" />

                </p>
                <p>
                    <span class="bold">Income: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.Income != null ? FamilyRecordData.Family.Income : null"
                                  v-bind:old-value-text="FamilyRecordData.Family.Income != null ? FamilyRecordData.Family.Income : ''"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Income"
                                  property-name="Income"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="true"
                                  v-bind:options="IncomeOptions" />

                </p>
                <p>
                    <span class="bold">Marital Status: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.MaritalStatus != null ? FamilyRecordData.Family.MaritalStatus : null"
                                  v-bind:old-value-text="FamilyRecordData.Family.MaritalStatus != null ? FamilyRecordData.Family.MaritalStatus : ''"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Marital Status"
                                  property-name="MaritalStatus"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="true"
                                  v-bind:options="MaritalStatus" />

                </p>
                <p>
                    <span class="bold">Marital Status Length of Relationship(Years): </span>
                    <IntegerEditor v-bind:old-value="FamilyRecordData.Family.MaritalStatusLengthOfRelationship"
                                   v-bind:record-id="FamilyRecordData.Family.Id"
                                   v-bind:edit-mode="EditMode"
                                   data-label="Marital Status Length of Relationship"
                                   property-name="MaritalStatusLengthOfRelationship"
                                   update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                   v-bind:required="true"
                                   :global-update="true" />
                </p>
                <p>
                    <span class="bold">Highest Level Of Education: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.HighestLevelOfEducation != null ? FamilyRecordData.Family.HighestLevelOfEducation : ''"
                                  v-bind:old-value-text="FamilyRecordData.Family.HighestLevelOfEducation != null ? FamilyRecordData.Family.HighestLevelOfEducation : ''"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Education Level"
                                  property-name="HighestLevelOfEducation"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="true"
                                  v-bind:options="EducationLevel" />

                </p>
                <p>
                    <span class="bold">Criminal History: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.CriminalHistory"
                                  v-bind:old-value-text="FamilyRecordData.Family.CriminalHistory  != null ? FamilyRecordData.Family.CriminalHistory == true ? 'Yes' : 'No' : ''"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Criminal History"
                                  property-name="CriminalHistory"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="true"
                                  v-bind:options="YesOrNoOption" />

                </p>
                <p v-if="!IsPNW">
                    <span class="bold">Exemption Required: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.ExemptionRequired"
                                  v-bind:old-value-text="FamilyRecordData.Family.ExemptionRequired  != null ? FamilyRecordData.Family.ExemptionRequired == true ? 'Yes' : 'No' : ''"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Exemption Required"
                                  property-name="ExemptionRequired"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="true"
                                  v-bind:options="YesOrNoOption" />

                </p>
                <p>
                    <span class="bold">Pre Existing Medical Diagnosis: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.PreExistingMedicalDiagnosis"
                                  v-bind:old-value-text="FamilyRecordData.Family.PreExistingMedicalDiagnosis  != null ? FamilyRecordData.Family.PreExistingMedicalDiagnosis == true ? 'Yes' : 'No' : ''"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Pre Existing Medical Diagnosis"
                                  property-name="PreExistingMedicalDiagnosis"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="true"
                                  v-bind:options="YesOrNoOption" />

                </p>
                <p>
                    <span class="bold">Medical Release Required: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.MedicalReleaseRequired"
                                  v-bind:old-value-text="FamilyRecordData.Family.MedicalReleaseRequired  != null ? FamilyRecordData.Family.MedicalReleaseRequired == true ? 'Yes' : 'No' : ''"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Medical Release Required"
                                  property-name="MedicalReleaseRequired"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="true"
                                  v-bind:options="YesOrNoOption" />

                </p>
                <p>
                    <span class="bold">Occupation: </span>
                    <StringEditor v-bind:old-value="FamilyRecordData.Family.Occupation"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Occupation"
                                  property-name="Occupation"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  v-bind:required="true" />
                </p>
                <p>
                    <span class="bold">Job Title: </span>
                    <StringEditor v-bind:old-value="FamilyRecordData.Family.OccupationTitle"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Occupation Title"
                                  property-name="OccupationTitle"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  v-bind:required="true" />
                </p>
                <p v-if="!IsPNW">
                    <span class="bold">Occupation Length(Months): </span>
                    <IntegerEditor v-bind:old-value="FamilyRecordData.Family.OccupationLength"
                                   v-bind:record-id="FamilyRecordData.Family.Id"
                                   v-bind:edit-mode="EditMode"
                                   data-label="Occupation Length"
                                   property-name="OccupationLength"
                                   update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                   v-bind:required="true"
                                   :global-update="true" />
                </p>
                <p>
                    <span class="bold">Needs Care Community: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.NeedsCareCommunity"
                                  v-bind:old-value-text="FamilyRecordData.NeedsCareCommunity == true ? 'Yes' : 'No'"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Needs Care Community"
                                  property-name="NeedsCareCommunity"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="true"
                                  v-bind:options="YesOrNoOption" />
                </p>
            </div>
            <div class="col col-md-4">
                <h4>Physical Address</h4>
                <AddressEditor v-bind:old-value="FamilyRecordData.Family.PhysicalAddress"
                               v-bind:record-id="FamilyRecordData.Family.PhysicalAddress.Id"
                               v-bind:edit-mode="EditMode"
                               data-label="Physical Address"
                               update-method="Core/Address/Update"
                               required="true" />
            </div>
            <div class="col col-md-4" v-if="FamilyRecordData.Family.MailingAddress">
                <h4>Mailing Address</h4>
                <AddressEditor v-bind:old-value="FamilyRecordData.Family.MailingAddress"
                               v-bind:record-id="FamilyRecordData.Family.MailingAddress.Id"
                               v-bind:edit-mode="EditMode"
                               data-label="Mailing Address"
                               update-method="Core/Address/Update"
                               required="true" />
            </div>
            
        </div>
        <div class="row">
            <div class="col col-md-4">
                <h4>Resource Parents <font-awesome-icon :icon="['fa', 'plus']" v-if="EditMode && FamilyRecordData.Family.Parents.filter(p => p.EndDate == null).length < 2 && CheckPermission('AddFosterParent')" v-on:click="ShowAddParent()" class="pointer olive-green-text" /></h4>
                <div v-for="parentMem in FamilyRecordData.Family.Parents" style="margin-bottom:10px;">
                    <div v-if="parentMem.Parent.Person.FirstName">
                        <p class="p-no-bottom-margin">
                            <!--<span class="bold">{{parentMem.Parent.Person.FullName}} </span> <span class="bold" v-if="parentMem.EndDate != null">(Dissociated {{ formatDate(parentMem.EndDate) }}) </span>-->
                            <PersonEditor :edit-mode="EditMode"
                                          :DOBRequired="false"
                                          :global-update="true"
                                          :inline="false"
                                          :control-buttons="true"
                                          :existing-person="parentMem.Parent.Person"
                                          :parent-id="parentMem.Parent.Id"
                                          :include-parent-charting="true"
                                          :include-pnw-parent-tracking="IsPNW"
                                          :sub-program-id="FamilyRecordData.FamilyProgramMembership.SubProgramID"
                                          :person-label-class="parentMem.EndDate != null ? 'lightgrey' : ''" /> <font-awesome-icon :icon="['fa', 'trash-alt']" v-if="EditMode && CheckPermission('RemoveFosterParent')" v-on:click="OpenParentEditDeleteModal(parentMem)" class="pointer" v-bind:class="{ lightgreytextforce: parentMem.EndDate != null, 'red': parentMem.EndDate == null }" />
                        </p>
                        <p v-if="parentMem.Parent.Person.Email" class="p-no-bottom-margin">Email: <a :href="'mailto:' + parentMem.Parent.Person.Email">{{parentMem.Parent.Person.Email}}</a></p>
                        <div v-for="phoneNumber in parentMem.Parent.Person.PhoneNumbers">
                            <p class="p-no-bottom-margin">{{ phoneNumber.PhoneNumber.PhoneType }}: {{ phoneNumber.PhoneNumber.FormattedPhoneNumber }} <span v-if="phoneNumber.PhoneNumber.Description">({{ phoneNumber.PhoneNumber.Description }})</span></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col col-md-4">
                <h4>Religion</h4>
                <!--<p>
                    <span class="bold">Church: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.ChurchID"
                                  v-bind:old-value-text="FamilyRecordData.Family.Church != null ? FamilyRecordData.Family.Church.Name : ''"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Church"
                                  property-name="ChurchID"
                                  update-method="Foster.Families.UpdateFamily"
                                  :required="true"
                                  v-bind:options="Churches" />

                </p>-->
                <p>
                    <span class="bold">Religious Affiliation: </span>
                    <StringEditor v-bind:old-value="FamilyRecordData.Family.ReligiousAffiliation"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Religious Affiliation"
                                  property-name="ReligiousAffiliation"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  v-bind:required="true" />

                </p>
                <p>
                    <span class="bold">Church: </span>
                    <StringEditor v-bind:old-value="FamilyRecordData.Family.DenominationComment"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Denomination Comment"
                                  property-name="DenominationComment"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  v-bind:required="true" />

                </p>
            </div>
            <div class="col col-md-4" v-if="IsPNW">
                <h4>PNW Tracking:</h4>
                <p>
                    <span class="bold">Current License Date: </span>
                    <DateEditor v-bind:old-value="FamilyRecordData.Family.CurrentLicenseDate"
                                v-bind:record-id="FamilyRecordData.Family.Id"
                                v-bind:edit-mode="EditMode"
                                data-label="Current License Date"
                                property-name="CurrentLicenseDate"
                                update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                :required="false"
                                :global-update="true" />

                </p>
                <p>
                    <span class="bold">License Expiration: </span>
                    <DateEditor v-bind:old-value="FamilyRecordData.Family.LicenseExpiration"
                                v-bind:record-id="FamilyRecordData.Family.Id"
                                v-bind:edit-mode="EditMode"
                                data-label="License Expiration"
                                property-name="LicenseExpiration"
                                update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                :required="false"
                                :global-update="true" />

                </p>
                <!--#TODO DELETE COLUMN FROM DATABASE TABLE (AutoInsuranceExpiration in FosterResourceFamily)
                    <p>
                    <span class="bold">Auto Insurance Expiration: </span>
                    <DateEditor v-bind:old-value="FamilyRecordData.Family.AutoInsuranceExpiration"
                                v-bind:record-id="FamilyRecordData.Family.Id"
                                v-bind:edit-mode="EditMode"
                                data-label="Auto Insurance Expiration"
                                property-name="AutoInsuranceExpiration"
                                update-method="Foster.Families.UpdateFamily"
                                :required="false"
                                :global-update="true" />

                </p>-->
                <p>
                    <span class="bold">Last HS Check Date: </span>
                    <DateEditor v-bind:old-value="FamilyRecordData.Family.LastHSCheckDate"
                                v-bind:record-id="FamilyRecordData.Family.Id"
                                v-bind:edit-mode="EditMode"
                                data-label="Last HS Check Date"
                                property-name="LastHSCheckDate"
                                update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                :required="false"
                                :global-update="true" />

                </p>
                <p>
                    <span class="bold">Kinship Family: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.IsKinshipFamily"
                                  v-bind:old-value-text="FamilyRecordData.Family.IsKinshipFamily  != null ? FamilyRecordData.Family.IsKinshipFamily == true ? 'Yes' : 'No' : ''"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Kinship Family?"
                                  property-name="IsKinshipFamily"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="true"
                                  v-bind:options="YesOrNoOption" />

                </p>
                <p>
                    <span class="bold">Age Licensed For: </span>
                    <StringEditor v-bind:old-value="FamilyRecordData.Family.AgeLicensedFor"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Age Licensed For"
                                  property-name="AgeLicensedFor"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  v-bind:required="false" />

                </p>
                <p>
                    <span class="bold">Gender Restrictions: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.GenderRestrictions"
                                  v-bind:old-value-text="FamilyRecordData.Family.GenderRestrictions"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Gender Restrictions"
                                  property-name="GenderRestrictions"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="false"
                                  v-bind:options="[{text:'None',value:'None'},{text:'Male or Female',value:'Male or Female'},{text:'M only',value:'M only'},{text:'F only',value:'F only'}]" />

                </p>
                <p>
                    <span class="bold">Respite Flag: </span>
                    <SelectEditor v-bind:old-value="FamilyRecordData.Family.RespiteFlag"
                                  v-bind:old-value-text="FamilyRecordData.Family.RespiteFlag  != null ? FamilyRecordData.Family.RespiteFlag == true ? 'Yes' : 'No' : ''"
                                  v-bind:record-id="FamilyRecordData.Family.Id"
                                  v-bind:edit-mode="EditMode"
                                  data-label="Respite Flag"
                                  property-name="RespiteFlag"
                                  update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                  :required="true"
                                  v-bind:options="YesOrNoOption" />

                </p>

            </div>
        </div>
        <b-modal ref="parent-remove-modal" title="Remove Parent?" hide-footer>
            <b-container>
                <b-row>
                    <b-col>
                        <h3>End Relationship</h3>
                        <div class="form-group">
                            <label>Date Ended:</label>
                            <flat-pickr v-model="EndParentData.Date" class="form-control" :config="DateConfig"></flat-pickr>
                            <button type="button" @click="EndParent()" class="form-control btn btn-warning">End Relationship</button>
                        </div>
                        <h3>Delete Parent</h3>
                        <div class="form-group">
                            <p>WARNING:  Deleting a parent should only be used if this person was never a Resource Parent with this family.  If the parent once was, but is no longer, associated with this Resource Family, choose "End Relationship" instead.</p>
                            <button type="button" @click="DeleteParent()" class="form-control btn btn-danger">Delete Parent</button>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
        <b-modal ref="parent-add-modal" title="Add Parent" hide-footer>
            <b-container>
                <b-form @submit="AddParent">
                    <PersonEditor :edit-mode="true"
                                  :DOBRequired="false"
                                  :global-update="true"
                                  :inline="true"
                                  end-point="tbd"
                                  :control-buttons="false"
                                  ref="parent-add-editor" />
                    <b-row>
                        <div class="form-group">
                            <label>Date Associated With Family:</label>
                            <flat-pickr v-model="AddParentData.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                        </div>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelAddParent()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode"/>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { EventBus } from '../../../../services/event-bus.js';
    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import StringEditor from '../../../Core/ItemEditors/StringEditor';
    import IntegerEditor from '../../../Core/ItemEditors/IntegerEditor';
    import DateEditor from '../../../Core/ItemEditors/DateEditor';
    import SelectEditor from '../../../Core/ItemEditors/SelectEditor';
    import AddressEditor from '../../../Core/ItemEditors/AddressEditor';
    import PersonEditor from '../../../Core/ItemEditors/PersonEditor';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    export default {
        props: [
            'FamilyRecordData'
        ],
        data: function () {
            return {
                EditMode: false,
                Churches: [],
                DateConfig: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: false
                },
                EndParentData: {
                    Date: "",
                    Id: ""
                },
                AddParentData: {
                    StartDate: ""
                },
                SubProgramTerritories: [],
                YesOrNoOption: [
                    {
                        text: "Yes",
                        value: true
                    },
                    {
                        text: "No",
                        value: false
                    }
                ]
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OpenParentEditDeleteModal(parentMem) {
                this.EndParentData.Id = parentMem.Id;
                this.EndParentData.Date = "";
                this.$refs["parent-remove-modal"].show();
            },
            ShowAddParent() {
                this.AddParentData.StartDate = "";
                this.$refs["parent-add-modal"].show();
            },
            CancelAddParent() {
                this.$refs["parent-add-modal"].hide();
            },
            AddParent(e) {
                e.preventDefault();
                //let vm = this;
                let personData = this.$refs["parent-add-editor"].GetUpdatedPerson();
                let addParentDataWithStartDate = { ...personData, ...this.AddParentData.StartDate, FosterResourceFamilyID: this.FamilyRecordData.Family.Id };
                console.log(addParentDataWithStartDate);
                this.$MasterAPI.ExecuteRequest("POST", "Foster/ResourceFamily/AddFosterResourceParent", addParentDataWithStartDate, this.AddParentSuccess, () => { }, true);
            },
            AddParentSuccess(response) {
                this.$GlobalUpdate.ExecuteGlobalUpdate();
                this.$refs["parent-add-modal"].hide();
            },
            EndParent() {
                //let vm = this;
                if (this.EndParentData.Date == null) {
                    return;
                }
                this.$MasterAPI.ExecuteRequest("POST", "Foster/ResourceFamily/EndFosterResourceParent", {Id: this.EndParentData.Id, Date: this.EndParentData.Date}, this.EndParentSuccess, () => { }, true);
            },
            EndParentSuccess(response) {
                this.$GlobalUpdate.ExecuteGlobalUpdate();
                this.$refs["parent-remove-modal"].hide();
            },
            DeleteParent() {
                this.$MasterAPI.ExecuteRequest("POST", "Foster/ResourceFamily/DeleteFosterResourceParent", {Id: this.EndParentData.Id}, this.DeleteParentSuccess, () => { }, true);
            },
            DeleteParentSuccess(response) {
                this.$GlobalUpdate.ExecuteGlobalUpdate();
                this.$refs["parent-remove-modal"].hide();
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            GetSubProgramTerritories() {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/ResourceFamily/SubProgramTerritories", { SubProgramID: this.FamilyRecordData.FamilyProgramMembership.SubProgramID }, this.GetSubProgramTerritoriesSuccess, () => { }, false);
            },
            GetSubProgramTerritoriesSuccess(response) {
                   for (var i = 0; i < response.data.data.length; i++) {
                       if (this.SubProgramTerritories[i] === undefined) {
                           this.SubProgramTerritories[i] = {}
                       };
                       this.SubProgramTerritories[i].text = response.data.data[i].Name;
                       this.SubProgramTerritories[i].value = response.data.data[i].Id;
                   }
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            flatPickr,
            StringEditor,
            DateEditor,
            SelectEditor,
            IntegerEditor,
            AddressEditor,
            PersonEditor,
            EditMode
        },
        mounted() {
            this.GetSubProgramTerritories();
        },
        computed: {
            SexOptions: function () {
                return this.$store.state.Options.Sexes;
            },
            RaceOptions: function () {
                return this.$store.state.Options.Races;
            },
            EthnicityOptions: function () {
                return this.$store.state.Options.Ethnicities;
            },
            IncomeOptions: function () {
                return this.$store.state.Options.IncomeLevels;
            },
            MaritalStatus: function () {
                return this.$store.state.Options.MaritalStatus;
            },
            EducationLevel: function () {
                return this.$store.state.Options.EducationLevel;
            },
            Languages: function () {
                return this.$store.state.Options.Languages;
            },
            IsPNW: function () {
                if (this.$store.state.Options.PNWSubPrograms.includes(this.FamilyRecordData.FamilyProgramMembership.SubProgramID.toUpperCase())) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
</script>

<style scoped>
</style>